import {
  css
} from 'lit';

export const HorizontalRuleStyle = css`
.lds-hr {
  height: var(--lds-spacing-hr-height);
  width: var(--lds-spacing-hr-width);

  margin-top: var(--lds-spacing-hr-margin-top);
  margin-right: var(--lds-spacing-hr-margin-right);
  margin-bottom: var(--lds-spacing-hr-margin-bottom);
  margin-left: var(--lds-spacing-hr-margin-left);
  opacity: var(--lds-color-hr-opacity);

  /* Reset all borders */
  border-color: var(--lds-color-transparent);
  border-style: none;
  border-width: 0;

  /* Style only the top border */
  border-top-color: var(--lds-color-hr-border-top);
  border-top-width: var(--lds-border-hr-top-width);
  border-top-style: var(--lds-border-hr-top-style);
}`;

export default HorizontalRuleStyle;
